import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

export const LookupDetailsModelSchema = z
  .object({
    id: z.string(),
    header_id: z.string(),
    label: z.string(),
    value: z.string().nullish(),
    sort_order: z.number().nullish(),
    // Critical Technology Areas are the one lookup group whose vocabulary a user
    // is not expected to know, so each option carries its own explanation:
    // `short_description` is the summary line the option list renders,
    // `description` the full published definition behind the field's help '?'.
    // Nullish because every other lookup group omits them.
    short_description: z.string().nullish(),
    description: z.string().nullish(),
    conditional_header_id: z.string().nullish(),
    conditional_detail_ids: z.array(z.string()).nullish()
  })
  .strict()

const LookupDetailsModelFields = makeFieldKeys(LookupDetailsModelSchema)

export type LookupDetailsModel = z.infer<typeof LookupDetailsModelSchema>

function validateLookupDetailsModel(data: unknown): LookupDetailsModel {
  try {
    return validateWithZodSchema(LookupDetailsModelSchema, data, 'lookup details model')
  } catch (error) {
    throw new Error(`Lookup details model validation failed: ${error}`)
  }
}
